import register from '../../../../global/js/registry';
export default register('m-searchfilter', () => import(/* webpackMode: "lazy" */ './m-searchfilter.controller'));
